import { ControllerFlowAPI, IWixWindow } from '@wix/yoshi-flow-editor';

export class WarmupData {
  private _warmupData: IWixWindow['warmupData'];
  private flowApi: ControllerFlowAPI;

  constructor(flowAPI: ControllerFlowAPI) {
    this.flowApi = flowAPI;

    this._warmupData = flowAPI.controllerConfig.wixCodeApi.window.warmupData;
  }

  get(key: string) {
    return this.flowApi.environment.isSSR
      ? undefined
      : this._warmupData.get(key);
  }

  set(key: string, data: unknown) {
    if (this.flowApi.environment.isSSR) {
      this._warmupData.set(key, data);
    }
  }
}
